import { configureStore } from '@reduxjs/toolkit';
import ideaSubmissionReducer from './slices/ideaSubmissionSlice';
// import userFeedbackReducer from '../apps/UserFeedbackApp/redux/userFeedbackSlice';



export const store = configureStore({
  reducer: {
    ideaSubmission: ideaSubmissionReducer,
    // userFeedback: userFeedbackReducer, 
  },
});

